import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    submittingFormInProgress: false,
    submittingFormError: null,

    masterList: [],
    selectedMasterList: null,

    organizationListForCurrentUser: [],

    formStatus: 'viewOnly',
    beforeEditData: null,

    removePopupVisible: false,
    addPopupVisible: false,
};

const organizationListSlice = createSlice({
    name: 'organizationList',
    initialState,
    reducers: {
        fetchMasterListStart: {
            reducer() {},
            prepare(forceRefresh = false) {
                return { payload: { forceRefresh } };
            },
        },
        fetchMasterListSuccess(state, { payload: companyList }) {
            state.masterList = companyList;
        },
        fetchOrganizationListForCurrentUserSuccess(state, { payload: organizationListForCurrentUser }) {
            state.organizationListForCurrentUser = organizationListForCurrentUser;
        },
        fetchOrganizationListForCurrentUserStart(state) {
            state.organizationListForCurrentUser = [];
        },
        setSelectedMasterListItem(state, { payload }) {
            state.selectedMasterList = payload ? state.masterList.find((comapny) => comapny.id === payload) : null;
        },
        setSelectedMasterListItemDetail(state, { payload: data }) {
            state.selectedMasterList = data;
        },
        submitFormStart(state) {
            state.submittingFormInProgress = true;
            state.submittingFormError = null;
        },
        submitFormFailed(state, { payload: error }) {
            state.submittingFormError = error;
            state.submittingFormInProgress = false;
        },
        submitFormSuccess(state, { payload: _ }) {
            state.submittingFormError = null;
            state.submittingFormInProgress = false;
        },
        setFormStatus(state, { payload: formStatus }) {
            state.formStatus = formStatus;
        },
        setBeforeEditData(state, { payload: personData = null }) {
            state.beforeEditData = personData;
        },
        removeErrorMessage(state) {
            state.submittingFormError = null;
        },
        resetState(state) {
            state.submittingFormInProgress = false;
            state.submittingFormError = null;
            state.formStatus = 'viewOnly';
            state.masterList = [];
            state.selectedMasterList = null;
            state.beforeEditData = null;
            state.selectedMasterList = null;
        },
        setRemovePopupVisible(state, { payload }) {
            state.removePopupVisible = payload;
        },
        setAddPopupVisible(state, { payload }) {
            state.addPopupVisible = payload;
        },
        addItemToMasterList() {},
    },
});

export const organizationListActions = organizationListSlice.actions;
export const organizationListReducer = organizationListSlice.reducer;
